import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getIsLoading = (state) => get(state, 'listsNew.isLoading', false);
export const getRoles = (state) => get(state, 'listsNew.entities.roles', {});
export const getRolesIds = (state) => get(state, 'listsNew.result.roles', []);
export const getPermissions = (state) => get(state, 'listsNew.permissions', []);

export const getVisibleRoles = createSelector([getRolesIds, getRoles], (ids, roles) =>
  ids.map((id) => roles[id])
);

export const getPermissionsBySection = createSelector([getPermissions], (permissions) =>
  permissions.reduce(
    (re, p) => {
      const section = p.split('.')[1];
      re.bySection[section] = re.bySection[section] || [];
      re.bySection[section].push(p);
      if (re.allSections.indexOf(section) === -1) re.allSections.push(section);
      return re;
    },
    { bySection: {}, allSections: [] }
  )
);



// WEBPACK FOOTER //
// src/modules/secured/modules/lists/selectors/lists_selectors.js